// @flow
import * as React from 'react'
import { Container, Bouncer } from './elements'

// Types
type Props = {
  color?: 'primary' | 'inherit',
  size?: 'normal' | 'small' | 'large' | 'inherit',
}

/**
 * Scalable loading spinner. You can pass some color/size via props,
 * or pass `color="inherith" size="inherit"` to define any color
 * and size (via `color` and `font-size`) CSS fields of parent element
 * that you like to use.
 * @param  {Object} props
 * @return {React.Element}
 */
const LoadingSpinner = (props: Props) => {
  const { size = 'normal', color = 'primary' } = props

  return (
    <Container $size={size}>
      <Bouncer $color={color} />
      <Bouncer $color={color} $delay />
    </Container>
  )
}

export default LoadingSpinner
